import { Box, Container, Grid } from '@mui/material'
import React from 'react'
import home from '../../assets/video/home.mp4'
import tokenomicspng from '../../assets/img/tokenomics.png'

import twitter from "../../assets/img/twitter.png"
import telegram from "../../assets/img/telegram.png"
import { ButtonEx, GridEx, PageWrapper, SocialImg, SocialMeidaBox, TypographyEx } from '../../styles'
import { telegramLink, twitterLink } from '../config'
import styled from '@emotion/styled'

const TypographyNew = styled(TypographyEx)`
    max-width: unset;
    margin: 0 auto;
    font-size: 5vw;

    @media (min-width: 1590px){ font-size: 67px; }
    @media (max-width: 1200px){ font-size: 5vw; }

    @media (max-width: 900px){ font-size: 5vw; margin-top: 25px; }

    @media (max-width: 600px){ font-size: 5vw; }
`

const Tokenomics = () => {
  return (
    <PageWrapper bg="#C20D00">
        <Container maxWidth="xl">
            <Grid container>
                <GridEx xs={12} item>
                    <TypographyNew variant="inherit" align="left">
                        Total Supply: 420,690,000,000,000<br />
                        Taxes: What Taxes!?<br />
                        Contract: TBA <br />
                    </TypographyNew>
                    <SocialMeidaBox>
                        <a href={twitterLink} target='_blank'>
                            <SocialImg src={twitter} alt="twitter-logo" />
                        </a>
                        <a href={telegramLink} target='_blank'>
                            <SocialImg src={telegram} alt="telegram-logo" />
                        </a>
                    </SocialMeidaBox>
                    <video className='tokenommicsVideo' style={{width: '100%', maxWidth: 400}} loop autoPlay muted>
                        <source src={home} type="video/mp4" />
                        Your browser does not support HTML video.
                    </video>
                    <Box sx={{textAlign: "right", mt:6 }}>
                        <ButtonEx bg="#FFCE00">EXPLORER</ButtonEx>
                        <ButtonEx bg="#FFFFFF" c="black">CHART</ButtonEx>
                    </Box>
                    <img src={tokenomicspng} alt="home-main-image" className='tokenomicsImg' />
                </GridEx>
            </Grid>
        </Container>
    </PageWrapper>
  )
}

export default Tokenomics